import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon_right",
  "use": "icon-icon_right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_right\"><defs><style></style></defs><path d=\"M391.168 823.296a25.6 25.6 0 0 1-18.022-7.578L43.418 485.99a25.6 25.6 0 0 1 36.044-35.43l311.706 310.886 552.96-552.96a25.6 25.6 0 0 1 36.25 36.25L409.6 815.718a25.6 25.6 0 0 1-18.432 7.578z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol